module.exports = "/images/Virtual reality.svg?516099147d22ac7d563775db1dde2d91";